import { apiGetClient, apiPostClient } from "../../api/apiSvtDashboard";

import { toast } from "react-toastify";

export const getRoles = async () => {
    try {
        const response = await apiGetClient.get(`/dashboards/roles`);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, {
            position: "top-center",
            theme: "dark",
        });
        return null;
    }
};

export const getSlotAndTemplates = async () => {
    try {
        const response = await apiGetClient.get(`dashboards/slots/assessments`);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, {
            position: "top-center",
            theme: "dark",
        });
        return null;
    }
};

export const getNonAdminFiltersData = async () => {
    try {
        const response = await apiGetClient.get(`/dashboards/filters`);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, {
            position: "top-center",
            theme: "dark",
        });
        return null;
    }
};

export const getRCMRegionFiltersData = async () => {
    try {
        const response = await apiGetClient.get(`/dashboards/regions/countries/user`);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, {
            position: "top-center",
            theme: "dark",
        });
        return null;
    }
};

export const getAdminSectorData = async () => {
    try {
        const response = await apiGetClient.get(`admin/sectors`);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, {
            position: "top-center",
            theme: "dark",
        });
        return null;
    }
};

export const getAdminBUData = async (sectorId) => {
    try {
        const response = await apiGetClient.get(
            `admin/sectors/${sectorId}/business-units`
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, {
            position: "top-center",
            theme: "dark",
        });
        return null;
    }
};

export const getAdminSubBUData = async (businessUnitId) => {
    try {
        const response = await apiGetClient.get(
            `admin/business-units/${businessUnitId}/sub-business-units`
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, {
            position: "top-center",
            theme: "dark",
        });
        return null;
    }
};

export const getAdminLE = async (subBusinessUnitId) => {
    try {
        const response = await apiPostClient.post(
            `admin/sub-business-units/legal-entities`,
            subBusinessUnitId
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, {
            position: "top-center",
            theme: "dark",
        });
        return null;
    }
};

export const getAdminRegions = async () => {
    try {
        const response = await apiGetClient.get(`admin/regions`);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, {
            position: "top-center",
            theme: "dark",
        });
        return null;
    }
};

export const getHitachiLevelDashboardData = async (
    slotId,
    templateMasterId
) => {
    try {
        const response = await apiGetClient.get(
            `/dashboards/parent-company?slotId=${slotId}&templateMasterId=${templateMasterId}`
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, {
            position: "top-center",
            theme: "dark",
        });
        return null;
    }
};

export const getSectorLevelDashboardData = async (
    slotId,
    templateMasterId,
    reqData
) => {
    try {
        const response = await apiPostClient.post(
            `/dashboards/sectors?slotId=${slotId}&templateMasterId=${templateMasterId}`,
            reqData
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, {
            position: "top-center",
            theme: "dark",
        });
        return null;
    }
};

export const getBULevelDashboardData = async (
    slotId,
    templateMasterId,
    reqData
) => {
    try {
        const response = await apiPostClient.post(
            `/dashboards/business-units?slotId=${slotId}&templateMasterId=${templateMasterId}`,
            reqData
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, {
            position: "top-center",
            theme: "dark",
        });
        return null;
    }
};

export const getSubBULevelDashboardData = async (
    slotId,
    templateMasterId,
    reqData
) => {
    try {
        const response = await apiPostClient.post(
            `/dashboards/sub-business-units?slotId=${slotId}&templateMasterId=${templateMasterId}`,
            reqData
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, {
            position: "top-center",
            theme: "dark",
        });
        return null;
    }
};

export const getLELevelDashboardData = async (
    slotId,
    templateMasterId,
    reqData
) => {
    try {
        const response = await apiPostClient.post(
            `/dashboards/legal-entities?slotId=${slotId}&templateMasterId=${templateMasterId}`,
            reqData
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, {
            position: "top-center",
            theme: "dark",
        });
        return null;
    }
};

export const getRegionLevelDashboardData = async (
    slotId,
    templateMasterId,
    reqData
) => {
    try {
        const response = await apiPostClient.post(
            `/dashboards/regions?slotId=${slotId}&templateMasterId=${templateMasterId}`,
            reqData
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, {
            position: "top-center",
            theme: "dark",
        });
        return null;
    }
};

export const getCountryLevelDashboardData = async (
    slotId,
    templateMasterId,
    reqData
) => {
    try {
        const response = await apiPostClient.post(
            `/dashboards/countries?slotId=${slotId}&templateMasterId=${templateMasterId}`,
            reqData
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, {
            position: "top-center",
            theme: "dark",
        });
        return null;
    }
};
